module.exports = __webpack_public_path__ + "img/jjin_final_1.de628ee9.jpg";